import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48aef025"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-4 pb-10" }
const _hoisted_2 = {
  key: 2,
  class: "random-wrap p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SongsCounter = _resolveComponent("SongsCounter")!
  const _component_NoSongs = _resolveComponent("NoSongs")!
  const _component_SongView = _resolveComponent("SongView")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SongsCounter),
    (_ctx.$store.state.mySongs.length === 0)
      ? (_openBlock(), _createBlock(_component_NoSongs, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.usedIdx.length > 0)
      ? (_openBlock(), _createBlock(_component_SongView, {
          key: 1,
          index: _ctx.usedIdx[_ctx.usedIdx.length - 1]
        }, null, 8, ["index"]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.filteredMySongs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            block: "",
            variant: "elevated",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getRandomSong())),
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Random song ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}